import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Download, Check, Loader2 } from 'lucide-react';

const PITCH_DECK_DRIVE_URL = "https://drive.google.com/file/d/1p3K0x-bxkp-NH4tbh-ti-dii2EOns_3z/view?usp=drive_link";

const PitchDeckButton: React.FC = () => {
  const [state, setState] = useState<'idle' | 'downloading' | 'success'>('idle');

  const handleDownload = () => {
    if (state !== 'idle') return;
    
    setState('downloading');
    
    // Preparation animation
    setTimeout(() => {
      setState('success');
      
      try {
        // Open the Google Drive link in a new tab
        window.open(PITCH_DECK_DRIVE_URL, '_blank');
      } catch (err) {
        console.error("Link failed to open:", err);
      }
      
      setTimeout(() => {
        setState('idle');
      }, 3000);
    }, 2500);
  };

  return (
    <motion.button
      onClick={handleDownload}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className={`relative h-14 md:h-20 px-8 md:px-12 rounded-2xl md:rounded-3xl flex items-center gap-4 font-black uppercase tracking-[0.2em] text-[10px] md:text-xs transition-all duration-500 overflow-hidden ${
        state === 'success' ? 'bg-emerald-600 text-white shadow-[0_0_30px_rgba(16,185,129,0.4)]' : 'glass-card text-gray-400 hover:text-white border-white/10 hover:border-rose-500/30'
      }`}
    >
      <AnimatePresence mode="wait">
        {state === 'idle' && (
          <motion.div
            key="idle"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="flex items-center gap-4"
          >
            <Download className="w-5 h-5 md:w-6 md:h-6 text-rose-500" />
            <span>View Pitch Deck</span>
          </motion.div>
        )}
        
        {state === 'downloading' && (
          <motion.div
            key="downloading"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="flex items-center gap-4"
          >
            <Loader2 className="w-5 h-5 md:w-6 md:h-6 animate-spin text-rose-500" />
            <span>Establishing Link...</span>
          </motion.div>
        )}
        
        {state === 'success' && (
          <motion.div
            key="success"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="flex items-center gap-4"
          >
            <Check className="w-5 h-5 md:w-6 md:h-6" />
            <span>Opening...</span>
          </motion.div>
        )}
      </AnimatePresence>

      {state === 'downloading' && (
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: "100%" }}
          transition={{ duration: 2.5, ease: "easeInOut" }}
          className="absolute bottom-0 left-0 h-1 bg-rose-500"
        />
      )}
    </motion.button>
  );
};

export default PitchDeckButton;